module.exports = __webpack_public_path__ + "img/cover.6ee37b0d.png";